import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const METRIC_RAM_RESOURCE = "metric" as const;
export const METRIC_RAM_OPERATION = "ram" as const;
export const METRIC_RAM_API_PATH = `/v1/${METRIC_RAM_RESOURCE}/${METRIC_RAM_OPERATION}` as const;

export type MetricResponse = paths[typeof METRIC_RAM_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useMetricRamQuery() {
  return useQuery({
    queryKey: [METRIC_RAM_RESOURCE, METRIC_RAM_OPERATION],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<MetricResponse>(METRIC_RAM_API_PATH);

      return response.data;
    },
  });
}
